import { Component, Input } from '@angular/core';
import { Icons } from '../../../constants/icons.constants';
@Component({
    selector: 'info-box',
    styleUrls: ['./info-box.component.scss'],
    template: `
        <div [class]="[level, 'box']">
            <div>
                <lsq-icon [type]="icon" [height]="20" [width]="20" class="icon"> </lsq-icon>
            </div>
            <div [style.width]="'100%'">
                <ng-content></ng-content>
            </div>
        </div>
    `
})
export class InfoBoxComponent {
    @Input() public level: 'warning' | 'error' = 'warning';
    @Input() public icon: string = Icons.FaExclamationCircle;
}
